import React from 'react';
import { useNavigate } from "react-router-dom";
import './ThemLinhVuc.css'
function ThemLinhVuc (){
    const navigate = useNavigate();
   
        return (
            <div>
       <div className="">
      <div className="add-new-linh-vuc-page">

        {/* Header */}
        <div className="add-new-linh-vuc-header">
          <h2 className="add-new-linh-vuc-title">Thêm lĩnh vực</h2>

          <div className="add-new-linh-vuc-breadcrumb">
            <span>Trang chủ</span>
            <span>/</span>
            <span>Quản lý lĩnh vực ngành</span>
            <span>/</span>
            <span>Lĩnh vực ngành</span>
            <span>/</span>
            <span>Thêm lĩnh vực</span>
          </div>
        </div>

        {/* Content */}
        <div className="add-new-linh-vuc-card">

          <div className="add-new-linh-vuc-body">

            {/* Left */}
            <div className="add-new-linh-vuc-left">

              <h4 className="add-new-linh-vuc-section-title">
                Thông tin lĩnh vực
              </h4>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Mã lĩnh vực <span>*</span>
                </label>

                <div className="add-new-linh-vuc-input-wrap">
                  <input
                    type="text"
                    className="add-new-linh-vuc-input"
                    placeholder="Nhập mã lĩnh vực"
                  />
                  <p className="add-new-linh-vuc-note">
                    Mã viết tắt, không trùng với mã lĩnh vực khác (VD: LV01)
                  </p>
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Tên lĩnh vực <span>*</span>
                </label>

                <input
                  type="text"
                  className="add-new-linh-vuc-input"
                  placeholder="Nhập tên lĩnh vực"
                />
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Nhóm lĩnh vực <span>*</span>
                </label>

                <select className="add-new-linh-vuc-select">
                  <option>-- Chọn nhóm lĩnh vực --</option>
                </select>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Mô tả
                </label>

                <div className="add-new-linh-vuc-textarea-wrap">
                  <textarea
                    className="add-new-linh-vuc-textarea"
                    placeholder="Nhập mô tả lĩnh vực"
                  ></textarea>

                  <span className="add-new-linh-vuc-counter">
                    0/255
                  </span>
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Thứ tự hiển thị
                </label>

                <div className="add-new-linh-vuc-input-wrap">
                  <input
                    type="number"
                    className="add-new-linh-vuc-input"
                    defaultValue="0"
                  />
                  <p className="add-new-linh-vuc-note">
                    Số thứ tự càng nhỏ hiển thị càng lên đầu
                  </p>
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Trạng thái <span>*</span>
                </label>

                <div className="add-new-linh-vuc-radio-group">
                  <label className="add-new-linh-vuc-radio">
                    <input type="radio" name="status" defaultChecked />
                    Hoạt động
                  </label>

                  <label className="add-new-linh-vuc-radio">
                    <input type="radio" name="status" />
                    Tạm dừng
                  </label>
                </div>
              </div>

            </div>

            {/* Right */}
            <div className="add-new-linh-vuc-right">

              <h4 className="add-new-linh-vuc-section-title">
                Thông tin bổ sung
              </h4>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Ngày hiệu lực
                </label>

                <div className="add-new-linh-vuc-date-wrap">
                  <input
                    type="date"
                    className="add-new-linh-vuc-input"
                  />
                  {/* <i className="fa-regular fa-calendar-days"></i> */}
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Đơn vị quản lý
                </label>

                <select className="add-new-linh-vuc-select">
                  <option>-- Chọn đơn vị --</option>
                </select>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Ghi chú
                </label>

                <div className="add-new-linh-vuc-textarea-wrap">
                  <textarea
                    className="add-new-linh-vuc-textarea"
                    placeholder="Nhập ghi chú (nếu có)"
                  ></textarea>

                  <span className="add-new-linh-vuc-counter">
                    0/255
                  </span>
                </div>
              </div>

              <div className="add-new-linh-vuc-guide">

                <div className="add-new-linh-vuc-guide-title">
                  <i className="fa-solid fa-circle-info"></i>
                  Hướng dẫn
                </div>

                <ul className="add-new-linh-vuc-guide-list">
                  <li>
                    Mã lĩnh vực là duy nhất và không thể thay đổi sau khi tạo.
                  </li>
                  <li>
                    Vui lòng chọn đúng nhóm lĩnh vực để dễ dàng quản lý và phân loại.
                  </li>
                  <li>
                    Trạng thái "Tạm dừng" sẽ ẩn lĩnh vực khỏi danh sách sử dụng.
                  </li>
                </ul>

              </div>

            </div>

          </div>

          {/* Footer */}
          <div className="add-new-linh-vuc-footer">

            <button className="add-new-linh-vuc-back-btn" onClick={() => navigate("/quan-tri-nganh")}>
              <i className="fa-solid fa-arrow-left"></i>
              Quay lại danh sách
            </button>

            <div className="add-new-linh-vuc-footer-right">

              <button className="add-new-linh-vuc-cancel-btn" onClick={() => navigate("/quan-tri-nganh")}>
                Hủy bỏ
              </button>

              <button className="add-new-linh-vuc-save-add-btn">
                <i className="fa-regular fa-floppy-disk"></i>
                Lưu và thêm mới
              </button>

              <button className="add-new-linh-vuc-save-btn">
                <i className="fa-regular fa-floppy-disk"></i>
                Lưu
              </button>

            </div>

          </div>

        </div>

      </div>
    </div>
            </div>
        );
    }


export default ThemLinhVuc;